
import reducer, * as selectors from "./reducer";
import actions from "./actions";
import * as config from "./const";

export default {
  reducer,
  actions,
  selectors,
  config
};



// WEBPACK FOOTER //
// ./src/sdk/config/index.js